module.exports = __webpack_public_path__ + "img/s3.e433b977.png";